import * as dayjs from 'dayjs';

import {
  RESET_NEW_DASHBOARD_DATA,
  SET_ACTIVE_USERS_IN_APP,
  SET_ANALYTICS_COUNT_DATE_RANGE,
  SET_AVG_FEEDBACK_DVM,
  SET_AVG_FEEDBACK_DVM_DATE_RANGE,
  SET_CALL_VOLUME_BY_DAY,
  SET_CALL_VOLUME_BY_HOUR,
  SET_CALL_VOLUME_DATE_RANGE,
  SET_CHAINED_HOSPITALS,
  SET_CLIENT_FEEDBACK_FOR_DVM,
  SET_CLIENT_PERCENTAGE,
  SET_CONSULTATION_COUNT,
  SET_DIRECT_REVENUE_COUNT,
  SET_DIRECT_REVENUE_LIST,
  SET_ER_REFS_COUNT,
  SET_HOSPITALS,
  SET_IN_DIRECT_REVENUE_COUNT,
  SET_IN_DIRECT_REVENUE_LIST,
  SET_NEW_CLIENTS_COUNT,
  SET_PETCO_WEB_VISIT_ANALYTICS,
  SET_SCHEDULED_APPOINTMENT_COUNT,
  SET_TOP_PERFORMING_DVM_DATE_RANGE,
  SET_TOP_PERFORMING_DVM_LIST_DATA,
  SET_TOTAL_APP_USERS,
  SET_TOTAL_REVENUE_GENERATED,
  SET_TRIAGE_TELEMED_DATE_RANGE,
  SET_TRIAGE_TELEMED_FEEDBACK,
  SET_USERS_IN_APP_DATE_RANGE,
} from '../types/Types';

const defaultDateRange = {
  type: 'This month',
  startDate: dayjs().startOf('month').toISOString(),
  endDate: dayjs().endOf('day').toISOString(),
};

const analyticsState = {
  totalRevenueGenerated: null,
  countDVM: 0,
  rowsDVM: [],
  offsetDVM: 0,
  limitDVM: 0,
  directRevenue: {},
  inDirectRevenue: {},
  avgFeedbackDVM: {},
  dvmFeedback: null,
  clientPercentage: 0,
  callsCountEveryDay: null,
  callsCountEveryHour: null,
  volumeDateRange: defaultDateRange,
  newClientsCount: 0,
  consultationCount: 0,
  scheduleAppointmentCount: 0,
  erRefsCount: 0,
  directRevenueList: [],
  inDirectRevenueList: [],
  analyticsCountDateRange: defaultDateRange,
  topPerformingDVMDateRange: defaultDateRange,
  triageTelemedDateRange: defaultDateRange,
  avgRatingDVMDateRange: defaultDateRange,
  triageTelemadFeedback: null,
  countTriageTelemed: 0,
  offsetTriageTelemed: 0,
  limitTriageTelemed: 0,
  hospitals: [],
  petcoWebVisitAnalytics: {},
  chainedHospitals: [],
  totalUsersInApp: null,
  activeUsersInApp: null,
  usersInAppDateRange: defaultDateRange,
};

const reducer = (state = analyticsState, action) => {
  switch (action.type) {
    case SET_DIRECT_REVENUE_COUNT:
      return {
        ...state,
        directRevenue: action.payload,
      };
    case SET_IN_DIRECT_REVENUE_COUNT:
      return {
        ...state,
        inDirectRevenue: action.payload,
      };
    case SET_CONSULTATION_COUNT:
      return {
        ...state,
        consultationCount: action.payload,
      };
    case SET_SCHEDULED_APPOINTMENT_COUNT:
      return {
        ...state,
        scheduleAppointmentCount: action.payload,
      };
    case SET_NEW_CLIENTS_COUNT:
      return {
        ...state,
        newClientsCount: action.payload,
      };
    case SET_ER_REFS_COUNT:
      return {
        ...state,
        erRefsCount: action.payload,
      };
    case SET_ANALYTICS_COUNT_DATE_RANGE: {
      return { ...state, analyticsCountDateRange: action.payload };
    }

    case SET_TOTAL_REVENUE_GENERATED: {
      return { ...state, totalRevenueGenerated: action.payload };
    }

    case SET_TOP_PERFORMING_DVM_LIST_DATA: {
      return {
        ...state,
        countDVM: action.payload.count,
        rowsDVM: action.payload.rows,
        offsetDVM: action.payload.offset,
        limitDVM: action.payload.limit,
      };
    }

    case SET_AVG_FEEDBACK_DVM: {
      return { ...state, avgFeedbackDVM: action.payload };
    }

    case SET_CLIENT_FEEDBACK_FOR_DVM: {
      return { ...state, dvmFeedback: action.payload };
    }
    case SET_CLIENT_PERCENTAGE: {
      return { ...state, clientPercentage: action.payload };
    }

    case SET_CALL_VOLUME_DATE_RANGE: {
      return { ...state, volumeDateRange: action.payload };
    }

    case SET_TOP_PERFORMING_DVM_DATE_RANGE: {
      return { ...state, topPerformingDVMDateRange: action.payload };
    }
    case SET_TRIAGE_TELEMED_DATE_RANGE: {
      return { ...state, triageTelemedDateRange: action.payload };
    }
    case SET_AVG_FEEDBACK_DVM_DATE_RANGE: {
      return { ...state, avgRatingDVMDateRange: action.payload };
    }

    case SET_CALL_VOLUME_BY_DAY: {
      return { ...state, callsCountEveryDay: action.payload };
    }
    case SET_CALL_VOLUME_BY_HOUR: {
      return { ...state, callsCountEveryHour: action.payload };
    }
    case SET_DIRECT_REVENUE_LIST: {
      return { ...state, directRevenueList: action.payload.rows };
    }
    case SET_IN_DIRECT_REVENUE_LIST: {
      return { ...state, inDirectRevenueList: action.payload.rows };
    }
    case SET_HOSPITALS: {
      return { ...state, hospitals: action.payload };
    }
    case SET_TRIAGE_TELEMED_FEEDBACK: {
      return {
        ...state,
        countTriageTelemed: action.payload.count,
        triageTelemadFeedback: action.payload.rows,
        offsetTriageTelemed: action.payload.offset,
        limitTriageTelemed: action.payload.limit,
      };
    }
    case SET_PETCO_WEB_VISIT_ANALYTICS: {
      const updatedData = {
        ...state.petcoWebVisitAnalytics,
        ...action.payload,
      };
      return { ...state, petcoWebVisitAnalytics: updatedData };
    }
    case SET_CHAINED_HOSPITALS: {
      return { ...state, chainedHospitals: action.payload };
    }

    case RESET_NEW_DASHBOARD_DATA:
      return {
        ...state,
        analyticsState,
      };
    case SET_TOTAL_APP_USERS: {
      return { ...state, totalUsersInApp: action.payload };
    }
    case SET_ACTIVE_USERS_IN_APP: {
      return { ...state, activeUsersInApp: action.payload };
    }
    case SET_USERS_IN_APP_DATE_RANGE: {
      return { ...state, usersInAppDateRange: action.payload };
    }
    default:
      return state;
  }
};

export default reducer;
